import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { State as AccessTokenState } from '~/AccessToken';
import { Product } from '~/Api/Product';
import { Price, selectPrice, State as DatasourceComputedPriceState } from '~/DatasourceComputedPrice';
import { ProductPrice } from '~/Product';

import { fetchPrices } from './actions';
import Info from './Info';

interface State {
	accessToken: AccessTokenState;
	datasourceComputedPrice: DatasourceComputedPriceState;
}

interface Props {
	priceType: string | null;
	product: Product;
	price: ProductPrice | null;
}

const memoizedSelectPrice = memoizeOne((state, accessToken, priceType, product, price) => {
	if (!accessToken) {
		return null;
	}
	const computed = price && price.origin.isComputed ? price.origin.computed : null;
	const calculationType = (computed && computed.calculationType) ?? `${product.dataset.source.type}-${priceType}`;
	return selectPrice(state, accessToken.user.id, calculationType);
});

function mapStateToProps(state: State, props: Props): { datasourceComputedPrice: Price | null; isFetching: boolean } {
	const { accessToken } = state.accessToken;

	return {
		datasourceComputedPrice: memoizedSelectPrice(
			state.datasourceComputedPrice,
			accessToken,
			props.priceType,
			props.product,
			props.price
		),
		isFetching: state.datasourceComputedPrice.isFetching,
	};
}

const actions: { onFetch: typeof fetchPrices } = {
	onFetch: fetchPrices,
};

export default connect(mapStateToProps, actions)(Info);
